import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";

export default {
  icon: ListAltOutlinedIcon,
};
